const MIKO_SIZE_INDEX = {
  "X-Small": 1, XS: 1,
  Small: 2, S: 2,
  Medium: 3, M: 3,
  Large: 4, L: 4,
  "X-Large": 5, XL: 5
};

function mikoCartRoutes() {
  const routes = (window.theme && window.theme.routes && window.theme.routes.cart) || {};
  return {
    add: `${routes.add || "/cart/add"}.js`,
    change: `${routes.change || "/cart/change"}.js`,
    update: `${routes.update || "/cart/update"}.js`,
    cart: `${routes.base || "/cart"}.js`,
    page: routes.base || "/cart"
  };
}

async function mikoJsonFetch(url, options = {}) {
  const response = await fetch(url, { credentials: "same-origin", ...options });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.status === 422) {
    throw new Error(data.description || data.message || "Unable to update the cart.");
  }
  return data;
}

async function mikoRefreshCart({ open = false, flash = null } = {}) {
  if (window.IraMiko && typeof window.IraMiko.refreshCart === "function") {
    return window.IraMiko.refreshCart({ open, flash });
  }
  if (open) window.location.href = mikoCartRoutes().page;
  return null;
}

function mikoShowFormError(form, message) {
  const error = form.querySelector("[data-error-message]");
  if (error) error.textContent = message || "Unable to add this set to the cart.";
  document.dispatchEvent(new CustomEvent("flu:cart:error", { detail: { errorMessage: message } }));
}

function mikoSetSizingInfo(wrapper, value) {
  if (!wrapper) return;
  const index = MIKO_SIZE_INDEX[value] || 0;
  wrapper.querySelectorAll("[data-miko-size-index]").forEach((item) => {
    item.classList.toggle("is-active", Number(item.dataset.mikoSizeIndex) === index);
  });
}

function mikoUpdateRegularSizing(select) {
  const position = select.id && select.id.match(/Option(\d+)/)?.[1];
  const scope = select.closest(".product-form-variant-block") || select.closest("form") || document;
  const wrappers = position
    ? scope.querySelectorAll(`[data-miko-sizing-info][data-miko-size-option-position="${position}"]`)
    : scope.querySelectorAll("[data-miko-sizing-info]");
  wrappers.forEach((wrapper) => mikoSetSizingInfo(wrapper, select.value));
}

document.addEventListener("change", (event) => {
  const select = event.target.closest('select[name^="options["]');
  if (select) mikoUpdateRegularSizing(select);
});

document.addEventListener("flu:product:variant-change", () => {
  document.querySelectorAll('select[name^="options["]').forEach(mikoUpdateRegularSizing);
});

// Mark size chips that are unavailable for the currently selected colour/length.
// The chips remain selectable so shoppers can see the sold-out state, but a
// diagonal line makes the unavailable sizes immediately clear.
const MIKO_PRODUCT_DATA_CACHE = new Map();

function mikoProductDataUrl(handle) {
  const base = (window.theme && window.theme.routes && window.theme.routes.products) || "/products";
  return `${base}/${handle}.js`;
}

async function mikoGetProductData(form) {
  const handle = form && form.dataset && form.dataset.productHandle;
  if (!handle) return null;
  if (!MIKO_PRODUCT_DATA_CACHE.has(handle)) {
    MIKO_PRODUCT_DATA_CACHE.set(
      handle,
      fetch(mikoProductDataUrl(handle), { credentials: "same-origin" })
        .then((response) => {
          if (!response.ok) throw new Error("Unable to load product availability.");
          return response.json();
        })
        .catch(() => null)
    );
  }
  return MIKO_PRODUCT_DATA_CACHE.get(handle);
}

function mikoSelectedProductOptions(form) {
  const selected = {};
  form.querySelectorAll('select[name^="options["]').forEach((select) => {
    const match = (select.id || "").match(/Option(\d+)/);
    if (match) selected[Number(match[1])] = select.value;
  });
  return selected;
}

function mikoApplySizeAvailability(form, productData) {
  if (!form || !productData || !Array.isArray(productData.variants)) return;
  const selected = mikoSelectedProductOptions(form);

  form.querySelectorAll("[data-miko-size-option-button]").forEach((button) => {
    const position = Number(button.dataset.mikoOptionPosition);
    const value = button.dataset.mikoOptionValue || "";
    const optionIndex = position - 1;

    const available = productData.variants.some((variant) => {
      if (!variant.available || variant.options[optionIndex] !== value) return false;
      return variant.options.every((variantValue, index) => {
        const otherPosition = index + 1;
        return otherPosition === position || !selected[otherPosition] || selected[otherPosition] === variantValue;
      });
    });

    button.classList.toggle("is-unavailable", !available);
    button.dataset.mikoUnavailable = String(!available);
    if (!button.dataset.mikoBaseLabel) {
      button.dataset.mikoBaseLabel = button.getAttribute("aria-label") || value;
    }
    button.setAttribute(
      "aria-label",
      available ? button.dataset.mikoBaseLabel : `${button.dataset.mikoBaseLabel} — sold out`
    );
  });
}

async function mikoInitSizeAvailability(root = document) {
  const forms = root.matches && root.matches("[data-product-form]")
    ? [root]
    : [...root.querySelectorAll("[data-product-form]")];

  await Promise.all(forms.map(async (form) => {
    if (!form.querySelector("[data-miko-size-option-button]")) return;
    const productData = await mikoGetProductData(form);
    if (productData) mikoApplySizeAvailability(form, productData);
  }));
}

document.addEventListener("change", (event) => {
  const select = event.target.closest('select[name^="options["]');
  if (!select) return;
  const form = select.closest("[data-product-form]");
  if (!form) return;
  window.setTimeout(async () => {
    const productData = await mikoGetProductData(form);
    if (productData) mikoApplySizeAvailability(form, productData);
  }, 0);
});

function mikoUpdateBundleProduct(fieldset) {
  const script = fieldset.querySelector("[data-miko-bundle-json]");
  if (!script) return;
  let product;
  try { product = JSON.parse(script.textContent); } catch (_) { return; }
  const selected = [...fieldset.querySelectorAll("[data-miko-bundle-option]")]
    .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
    .map((select) => select.value);
  const variant = product.variants.find((candidate) =>
    candidate.options.every((option, index) => option === selected[index])
  );
  const available = Boolean(variant && variant.available);
  fieldset.dataset.selectedVariantId = available ? String(variant.id) : "";
  const warning = fieldset.querySelector("[data-miko-bundle-unavailable]");
  if (warning) warning.hidden = available;
  fieldset.querySelectorAll("[data-miko-bundle-option]").forEach((select) => {
    const wrapper = fieldset.querySelector(`[data-miko-sizing-info][data-miko-size-option-position="${select.dataset.optionPosition}"]`);
    if (wrapper) mikoSetSizingInfo(wrapper, select.value);
  });
  const form = fieldset.closest("form");
  const button = form && form.querySelector("[data-miko-bundle-add]");
  if (button) {
    const allAvailable = [...form.querySelectorAll("[data-miko-bundle-product]")]
      .every((item) => Boolean(item.dataset.selectedVariantId));
    button.disabled = !allAvailable;
    button.setAttribute("aria-disabled", String(!allAvailable));
  }
}

function mikoInitBundles(root = document) {
  root.querySelectorAll("[data-miko-bundle-product]").forEach(mikoUpdateBundleProduct);
}

document.addEventListener("change", (event) => {
  const select = event.target.closest("[data-miko-bundle-option]");
  if (select) mikoUpdateBundleProduct(select.closest("[data-miko-bundle-product]"));
});

document.addEventListener("submit", async (event) => {
  if (window.Shopify?.designMode) return;
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.querySelector("[data-miko-bundle-products]")) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const button = form.querySelector("[data-miko-bundle-add]");
  const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));
  const items = [...form.querySelectorAll("[data-miko-bundle-product]")].map((item) => ({
    id: Number(item.dataset.selectedVariantId),
    quantity
  }));
  if (!items.length || items.some((item) => !item.id)) {
    mikoShowFormError(form, "Please select an available option for every item.");
    return;
  }
  button?.classList.add("loading");
  if (button) button.disabled = true;
  try {
    const result = await mikoJsonFetch(mikoCartRoutes().add, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items })
    });
    const first = result.items && result.items[0];
    document.dispatchEvent(new CustomEvent("flu:cart:item-added", { detail: { product: first || result } }));
    await mikoRefreshCart({ open: document.body.dataset.enableQuickCart === "true", flash: first && first.variant_id });
    if (document.body.dataset.enableQuickCart !== "true") window.location.href = mikoCartRoutes().page;
  } catch (error) {
    mikoShowFormError(form, error.message);
  } finally {
    button?.classList.remove("loading");
    mikoInitBundles(form);
  }
}, true);

async function mikoAddCardVariant(button) {
  if (button.disabled) return;
  button.classList.add("is-loading");
  button.disabled = true;
  try {
    const result = await mikoJsonFetch(mikoCartRoutes().add, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
    });
    const item = result.items && result.items[0];
    document.dispatchEvent(new CustomEvent("flu:cart:item-added", { detail: { product: item || result } }));
    await mikoRefreshCart({ open: document.body.dataset.enableQuickCart === "true", flash: item && item.variant_id });
    if (document.body.dataset.enableQuickCart !== "true") window.location.href = mikoCartRoutes().page;
  } catch (error) {
    document.dispatchEvent(new CustomEvent("flu:cart:error", { detail: { errorMessage: error.message } }));
    window.alert(error.message);
  } finally {
    button.classList.remove("is-loading");
    button.disabled = false;
  }
}

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-miko-card-add]");
  if (button) {
    event.preventDefault();
    mikoAddCardVariant(button);
  }
});

function mikoSyncGiftWrap(cart) {
  if (!cart || !Array.isArray(cart.items)) return;
  document.querySelectorAll("[data-miko-gift-wrap]").forEach((checkbox) => {
    const id = Number(checkbox.dataset.variantId);
    checkbox.checked = cart.items.some((item) => Number(item.variant_id) === id);
  });
}

document.addEventListener("change", async (event) => {
  const checkbox = event.target.closest("[data-miko-gift-wrap]");
  if (!checkbox) return;
  checkbox.disabled = true;
  const id = Number(checkbox.dataset.variantId);
  try {
    if (checkbox.checked) {
      await mikoJsonFetch(mikoCartRoutes().add, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
    } else {
      await mikoJsonFetch(mikoCartRoutes().change, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ id, quantity: 0 })
      });
    }
    const cart = await mikoRefreshCart();
    mikoSyncGiftWrap(cart);
    if (document.body.classList.contains("template-cart")) window.location.reload();
  } catch (error) {
    checkbox.checked = !checkbox.checked;
    window.alert(error.message);
  } finally {
    checkbox.disabled = false;
  }
});

document.addEventListener("flu:cart:updated", (event) => mikoSyncGiftWrap(event.detail && event.detail.cart));

const MIKO_VIEW_KEY = "miko_collection_view_mode";
function mikoApplyViewMode(mode) {
  const safeMode = mode === "item" ? "item" : "model";
  document.documentElement.dataset.mikoViewMode = safeMode;
  try { localStorage.setItem(MIKO_VIEW_KEY, safeMode); } catch (_) {}
  document.querySelectorAll("[data-miko-view-mode-toggle]").forEach((button) => {
    const label = safeMode === "item" ? button.dataset.itemLabel : button.dataset.modelLabel;
    if (button.textContent !== label) button.textContent = label;
    button.setAttribute("aria-pressed", String(safeMode === "item"));
  });
}

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-miko-view-mode-toggle]");
  if (!button) return;
  event.preventDefault();
  mikoApplyViewMode(document.documentElement.dataset.mikoViewMode === "item" ? "model" : "item");
});

async function mikoFilterGallery(select) {
  const container = select.closest(".product__media-container");
  const slider = container && container.querySelector("[data-slider]");
  if (!slider) return;
  if (!slider._mikoAllSlides) {
    slider._mikoAllSlides = [...slider.querySelectorAll(":scope > [data-slide]")]
      .sort((a, b) => Number(a.dataset.mikoMediaOrder) - Number(b.dataset.mikoMediaOrder));
  }
  const wanted = select.value;
  const slides = slider._mikoAllSlides.filter((slide) => wanted === "all" || slide.dataset.mikoModelFilter === wanted);
  if (!slides.length) return;
  try {
    const { Flickity } = await import(window.flu.chunks.flickity);
    const instance = Flickity.data(slider);
    if (instance) {
      const current = instance.getCellElements();
      if (current.length) instance.remove(current);
      const pagination = slider.querySelector(".mobile-carousel__pagination");
      slides.forEach((slide) => {
        slide.hidden = false;
        slider.insertBefore(slide, pagination || null);
      });
      instance.reloadCells();
      instance.resize();
      instance.select(0, false, true);
    } else {
      slider._mikoAllSlides.forEach((slide) => { slide.hidden = !slides.includes(slide); });
    }
  } catch (_) {
    slider._mikoAllSlides.forEach((slide) => { slide.hidden = !slides.includes(slide); });
  }
  slider.dispatchEvent(new CustomEvent("miko:gallery-filtered", { bubbles: true }));
}

document.addEventListener("change", (event) => {
  const select = event.target.closest("[data-miko-media-filter-select]");
  if (select) mikoFilterGallery(select);
});

function mikoInit(root = document) {
  let saved = "model";
  try { saved = localStorage.getItem(MIKO_VIEW_KEY) || "model"; } catch (_) {}
  mikoApplyViewMode(saved);
  mikoInitBundles(root);
  mikoInitSizeAvailability(root);
  root.querySelectorAll('select[name^="options["]').forEach(mikoUpdateRegularSizing);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => mikoInit());
} else {
  mikoInit();
}
document.addEventListener("quickview:loaded", () => mikoInit());
document.addEventListener("shopify:section:load", (event) => mikoInit(event.target));


// On touch devices, the first image tap reveals sizes and the second product image.
// A second tap follows the product link, matching hover behaviour without trapping navigation.
function mikoCloseTouchCards(except = null) {
  document.querySelectorAll("[data-miko-product-media].is-touch-active").forEach((media) => {
    if (media !== except) media.classList.remove("is-touch-active");
  });
}

document.addEventListener("click", (event) => {
  const imageLink = event.target.closest(".product-item__image-link");
  const supportsTouchReveal = window.matchMedia("(hover: none), (pointer: coarse)").matches;

  if (imageLink && supportsTouchReveal) {
    const media = imageLink.closest("[data-miko-product-media]");
    if (media && !media.classList.contains("is-touch-active")) {
      event.preventDefault();
      mikoCloseTouchCards(media);
      media.classList.add("is-touch-active");
      return;
    }
  }

  if (!event.target.closest("[data-miko-product-card]")) {
    mikoCloseTouchCards();
  }
});


// Show and update a compact "1 / 6" product-media counter on mobile.
// This implementation is intentionally event-driven. Flickity changes classes and
// inline styles while it runs, so observing the whole slider can create a recursive
// MutationObserver loop inside Shopify's mobile theme-editor preview.
const mikoMediaCounterCleanups = new WeakMap();
let mikoFlickityImportPromise = null;

function mikoGetFlickityModule() {
  if (!mikoFlickityImportPromise) {
    const path = window.flu?.chunks?.flickity;
    mikoFlickityImportPromise = path
      ? import(path)
      : Promise.reject(new Error("Flickity module path is unavailable"));
  }
  return mikoFlickityImportPromise;
}

function mikoVisibleGallerySlides(slider, instance = null) {
  let slides = [];
  if (instance) {
    slides = typeof instance.getCellElements === "function"
      ? instance.getCellElements()
      : (instance.cells || []).map((cell) => cell.element).filter(Boolean);
  }
  if (!slides.length) {
    slides = [...slider.querySelectorAll(":scope > [data-slide]")];
  }
  return slides.filter((slide) => slide && !slide.hidden && slide.style.display !== "none");
}

function mikoWriteMediaCounter(counter, currentEl, totalEl, current, total) {
  const safeTotal = Math.max(Number(total) || 0, 0);
  const safeCurrent = safeTotal ? Math.min(Math.max(Number(current) || 1, 1), safeTotal) : 0;
  const currentText = String(safeCurrent || 1);
  const totalText = String(safeTotal || 1);

  if (currentEl && currentEl.textContent !== currentText) currentEl.textContent = currentText;
  if (totalEl && totalEl.textContent !== totalText) totalEl.textContent = totalText;

  const label = `Product image ${currentText} of ${totalText}`;
  if (counter.getAttribute("aria-label") !== label) counter.setAttribute("aria-label", label);

  const shouldHide = safeTotal <= 1;
  if (counter.hidden !== shouldHide) counter.hidden = shouldHide;
}

function mikoDestroyProductMediaCounter(counter) {
  const cleanup = mikoMediaCounterCleanups.get(counter);
  if (cleanup) cleanup();
  mikoMediaCounterCleanups.delete(counter);
  delete counter.dataset.mikoCounterInitialized;
}

function mikoDestroyProductMediaCounters(root = document) {
  const counters = root.matches?.("[data-miko-media-counter]")
    ? [root]
    : [...root.querySelectorAll("[data-miko-media-counter]")];
  counters.forEach(mikoDestroyProductMediaCounter);
}

function mikoInitProductMediaCounters(root = document) {
  const counters = root.matches?.("[data-miko-media-counter]")
    ? [root]
    : [...root.querySelectorAll("[data-miko-media-counter]")];

  counters.forEach((counter) => {
    if (counter.dataset.mikoCounterInitialized === "true") return;

    const slider = counter.closest("[data-slider]");
    if (!slider) return;

    counter.dataset.mikoCounterInitialized = "true";
    const currentEl = counter.querySelector("[data-miko-media-current]");
    const totalEl = counter.querySelector("[data-miko-media-total]");
    let instance = null;
    let retryTimer = null;
    let frame = null;
    let destroyed = false;
    let retries = 0;

    const update = () => {
      if (destroyed || !counter.isConnected || !slider.isConnected) return;
      const slides = mikoVisibleGallerySlides(slider, instance);
      const selectedElement = instance?.selectedElement || instance?.selectedCell?.element;
      let index = selectedElement ? slides.indexOf(selectedElement) : -1;
      if (index < 0) {
        const selectedSlide = slides.findIndex((slide) =>
          slide.classList.contains("is-selected") || slide.classList.contains("initial")
        );
        index = selectedSlide >= 0 ? selectedSlide : Math.min(Number(instance?.selectedIndex) || 0, Math.max(slides.length - 1, 0));
      }
      mikoWriteMediaCounter(counter, currentEl, totalEl, index + 1, slides.length);
    };

    const scheduleUpdate = () => {
      if (destroyed) return;
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        frame = null;
        update();
      });
    };

    const connect = async () => {
      if (destroyed || !counter.isConnected || !slider.isConnected) return;
      try {
        const { Flickity } = await mikoGetFlickityModule();
        instance = Flickity.data(slider);
        if (!instance) {
          const maxRetries = window.Shopify?.designMode ? 20 : 50;
          if (retries < maxRetries) {
            retries += 1;
            retryTimer = window.setTimeout(connect, 100);
          }
          return;
        }

        instance.on("select", scheduleUpdate);
        instance.on("change", scheduleUpdate);
        instance.on("cellChange", scheduleUpdate);
        instance.on("settle", scheduleUpdate);
        slider.addEventListener("miko:gallery-filtered", scheduleUpdate);
        scheduleUpdate();
      } catch (_) {
        // The Liquid-rendered count remains available if Flickity is unavailable.
        update();
      }
    };

    const cleanup = () => {
      destroyed = true;
      if (retryTimer) window.clearTimeout(retryTimer);
      if (frame) window.cancelAnimationFrame(frame);
      slider.removeEventListener("miko:gallery-filtered", scheduleUpdate);
      if (instance?.off) {
        instance.off("select", scheduleUpdate);
        instance.off("change", scheduleUpdate);
        instance.off("cellChange", scheduleUpdate);
        instance.off("settle", scheduleUpdate);
      }
    };

    mikoMediaCounterCleanups.set(counter, cleanup);
    update();
    connect();
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => mikoInitProductMediaCounters());
} else {
  mikoInitProductMediaCounters();
}
document.addEventListener("quickview:loaded", () => mikoInitProductMediaCounters());
document.addEventListener("shopify:section:load", (event) => mikoInitProductMediaCounters(event.target));
document.addEventListener("shopify:section:unload", (event) => mikoDestroyProductMediaCounters(event.target));


// Miko embroidery personaliser — stable Ira 5.4.6
function mikoEmbroideryValue(root, selector) {
  return root.querySelector(`${selector}:checked`)?.value || "";
}

function mikoEmbroiderySetProperty(root, key, value) {
  const input = root.querySelector(`[data-miko-embroidery-property="${key}"]`);
  if (!input) return;
  input.value = value || "";
  input.disabled = !value;
}

function mikoUpdateEmbroideryPreview(root) {
  const first = root.querySelector("[data-miko-embroidery-first]");
  const second = root.querySelector("[data-miko-embroidery-second]");
  const firstPreview = root.querySelector("[data-miko-embroidery-preview-first]");
  const secondPreview = root.querySelector("[data-miko-embroidery-preview-second]");
  const preview = root.querySelector("[data-miko-embroidery-preview-text]");
  const position = mikoEmbroideryValue(root, "[data-miko-embroidery-position]") || "Left chest";
  const colour = mikoEmbroideryValue(root, "[data-miko-embroidery-colour]") || "White";
  const font = mikoEmbroideryValue(root, "[data-miko-embroidery-font]") || "Block";

  if (firstPreview) firstPreview.textContent = first?.value.trim() || "Your name";
  if (secondPreview) {
    secondPreview.textContent = second?.value.trim() || "";
    secondPreview.hidden = !second?.value.trim();
  }
  if (first && root.querySelector("[data-miko-embroidery-first-count]")) {
    root.querySelector("[data-miko-embroidery-first-count]").textContent = String(first.value.length);
  }
  if (second && root.querySelector("[data-miko-embroidery-second-count]")) {
    root.querySelector("[data-miko-embroidery-second-count]").textContent = String(second.value.length);
  }
  if (preview) {
    preview.classList.toggle("is-left", position === "Left chest");
    preview.classList.toggle("is-right", position === "Right chest");
    preview.classList.toggle("is-white", colour === "White");
    preview.classList.toggle("is-black", colour === "Black");
    preview.classList.toggle("is-block", font === "Block");
    preview.classList.toggle("is-script", font === "Script");
  }
}

function mikoOpenEmbroidery(root) {
  const modal = root.querySelector("[data-miko-embroidery-modal]");
  if (!modal) return;
  modal.hidden = false;
  document.body.classList.add("miko-embroidery-modal-open");
  window.requestAnimationFrame(() => root.querySelector("[data-miko-embroidery-first]")?.focus());
  mikoUpdateEmbroideryPreview(root);
}

function mikoCloseEmbroidery(root) {
  const modal = root.querySelector("[data-miko-embroidery-modal]");
  if (modal) modal.hidden = true;
  document.body.classList.remove("miko-embroidery-modal-open");
}

function mikoOpenEmbroideryInfo(root) {
  const modal = root.querySelector("[data-miko-embroidery-info-modal]");
  if (!modal) return;
  modal.hidden = false;
  document.body.classList.add("miko-embroidery-modal-open");
  window.requestAnimationFrame(() => root.querySelector("[data-miko-embroidery-info-start]")?.focus());
}

function mikoCloseEmbroideryInfo(root) {
  const modal = root.querySelector("[data-miko-embroidery-info-modal]");
  if (modal) modal.hidden = true;
  if (root.querySelector("[data-miko-embroidery-modal]")?.hidden !== false) {
    document.body.classList.remove("miko-embroidery-modal-open");
  }
}

function mikoStartEmbroideryFromInfo(root) {
  mikoCloseEmbroideryInfo(root);
  mikoOpenEmbroidery(root);
}

function mikoResetEmbroideryFields(root) {
  root.querySelectorAll("[data-miko-embroidery-first], [data-miko-embroidery-second]").forEach((input) => { input.value = ""; });
  root.querySelectorAll("[data-miko-embroidery-position], [data-miko-embroidery-colour], [data-miko-embroidery-font]").forEach((input) => {
    input.checked = input.defaultChecked;
  });
  const terms = root.querySelector("[data-miko-embroidery-terms]");
  if (terms) terms.checked = false;
  const error = root.querySelector("[data-miko-embroidery-error]");
  if (error) error.hidden = true;
  mikoUpdateEmbroideryPreview(root);
}

function mikoRemoveEmbroidery(root) {
  root.dataset.mikoEmbroiderySelected = "false";
  root.querySelectorAll("[data-miko-embroidery-property]").forEach((input) => {
    input.value = "";
    input.disabled = true;
  });
  const selection = root.querySelector("[data-miko-embroidery-selection]");
  const trigger = root.querySelector(".miko-embroidery__trigger");
  const summary = root.querySelector("[data-miko-embroidery-summary]");
  if (selection) {
    selection.hidden = true;
    selection.setAttribute("hidden", "");
  }
  if (trigger) {
    trigger.hidden = false;
    trigger.removeAttribute("hidden");
  }
  if (summary) summary.textContent = "";
  mikoResetEmbroideryFields(root);
  mikoCloseEmbroidery(root);
  mikoCloseEmbroideryInfo(root);
}

function mikoApplyEmbroidery(root) {
  const first = root.querySelector("[data-miko-embroidery-first]")?.value.trim() || "";
  const second = root.querySelector("[data-miko-embroidery-second]")?.value.trim() || "";
  const position = mikoEmbroideryValue(root, "[data-miko-embroidery-position]");
  const colour = mikoEmbroideryValue(root, "[data-miko-embroidery-colour]");
  const font = mikoEmbroideryValue(root, "[data-miko-embroidery-font]");
  const terms = root.querySelector("[data-miko-embroidery-terms]");
  const error = root.querySelector("[data-miko-embroidery-error]");

  if (!first) {
    if (error) { error.textContent = "Please enter the first line of embroidery text."; error.hidden = false; }
    root.querySelector("[data-miko-embroidery-first]")?.focus();
    return;
  }
  if (terms && !terms.checked) {
    if (error) { error.textContent = "Please confirm the final-sale and production-time terms."; error.hidden = false; }
    terms.focus();
    return;
  }
  if (error) error.hidden = true;

  mikoEmbroiderySetProperty(root, "first", first);
  mikoEmbroiderySetProperty(root, "second", second);
  mikoEmbroiderySetProperty(root, "position", position);
  mikoEmbroiderySetProperty(root, "colour", colour);
  mikoEmbroiderySetProperty(root, "font", font);
  mikoEmbroiderySetProperty(root, "terms", "Accepted — final sale");
  root.dataset.mikoEmbroiderySelected = "true";

  const summary = root.querySelector("[data-miko-embroidery-summary]");
  if (summary) summary.textContent = [first, second, position, colour, font].filter(Boolean).join(" · ");
  const selection = root.querySelector("[data-miko-embroidery-selection]");
  const trigger = root.querySelector(".miko-embroidery__trigger");
  if (selection) selection.hidden = false;
  if (trigger) trigger.hidden = true;
  mikoCloseEmbroidery(root);
}

function mikoInitEmbroidery(root = document) {
  const widgets = root.matches?.("[data-miko-embroidery]") ? [root] : [...root.querySelectorAll("[data-miko-embroidery]")];
  widgets.forEach((widget) => {
    if (widget.dataset.mikoEmbroideryInitialized === "true") return;
    widget.dataset.mikoEmbroideryInitialized = "true";
    // A product page must always begin with no embroidery selected. This also
    // prevents browser/page-transition DOM restoration from carrying a previous
    // product's personalisation interface into the next product.
    mikoRemoveEmbroidery(widget);
    widget.querySelectorAll("[data-miko-embroidery-open]").forEach((button) => button.addEventListener("click", () => mikoOpenEmbroidery(widget)));
    widget.querySelectorAll("[data-miko-embroidery-close]").forEach((button) => button.addEventListener("click", () => mikoCloseEmbroidery(widget)));
    widget.querySelectorAll("[data-miko-embroidery-info-open]").forEach((button) => button.addEventListener("click", () => mikoOpenEmbroideryInfo(widget)));
    widget.querySelectorAll("[data-miko-embroidery-info-close]").forEach((button) => button.addEventListener("click", () => mikoCloseEmbroideryInfo(widget)));
    widget.querySelector("[data-miko-embroidery-info-start]")?.addEventListener("click", () => mikoStartEmbroideryFromInfo(widget));
    widget.querySelector("[data-miko-embroidery-apply]")?.addEventListener("click", () => mikoApplyEmbroidery(widget));
    widget.querySelector("[data-miko-embroidery-remove]")?.addEventListener("click", () => mikoRemoveEmbroidery(widget));
    widget.querySelector("[data-miko-embroidery-reset]")?.addEventListener("click", () => mikoResetEmbroideryFields(widget));
    widget.querySelectorAll("[data-miko-embroidery-first], [data-miko-embroidery-second]").forEach((input) => input.addEventListener("input", () => mikoUpdateEmbroideryPreview(widget)));
    widget.querySelectorAll("[data-miko-embroidery-position], [data-miko-embroidery-colour], [data-miko-embroidery-font]").forEach((input) => input.addEventListener("change", () => mikoUpdateEmbroideryPreview(widget)));
    widget.addEventListener("keydown", (event) => {
      if (event.key !== "Escape") return;
      if (!widget.querySelector("[data-miko-embroidery-info-modal]")?.hidden) {
        mikoCloseEmbroideryInfo(widget);
      } else if (!widget.querySelector("[data-miko-embroidery-modal]")?.hidden) {
        mikoCloseEmbroidery(widget);
      }
    });
    mikoUpdateEmbroideryPreview(widget);
  });
}

function mikoCollectLineProperties(form) {
  const properties = {};
  form.querySelectorAll('[name^="properties["]').forEach((input) => {
    if (input.disabled || ((input.type === "checkbox" || input.type === "radio") && !input.checked)) return;
    const match = input.name.match(/^properties\[(.+)\]$/);
    if (match && input.value !== "") properties[match[1]] = input.value;
  });
  return properties;
}

function mikoEmbroideryGroupId() {
  return `miko-${Date.now().toString(36)}-${Math.random().toString(36).slice(2,10)}`;
}

const MIKO_EMBROIDERY_MAIN_PROPERTY_NAMES = new Set([
  "Embroidery first line",
  "Embroidery second line",
  "Embroidery position",
  "Embroidery thread colour",
  "Embroidery font",
  "Embroidery terms",
  "_Miko embroidery group",
  "_Miko embroidery add-on variant"
]);

function mikoWithoutEmbroideryProperties(properties) {
  const cleaned = {};
  Object.entries(properties || {}).forEach(([name, value]) => {
    if (!MIKO_EMBROIDERY_MAIN_PROPERTY_NAMES.has(name)) cleaned[name] = value;
  });
  return cleaned;
}

function mikoEmbroideryAddonPropertiesFromMain(main, group) {
  const properties = main?.properties || {};
  return {
    "_Miko embroidery add-on": "true",
    "_Miko embroidery group": group,
    "_Miko embroidery for": main?.product_title || "Garment",
    "_Embroidery first line": properties["Embroidery first line"] || "",
    "_Embroidery second line": properties["Embroidery second line"] || "",
    "_Embroidery position": properties["Embroidery position"] || "",
    "_Embroidery thread colour": properties["Embroidery thread colour"] || "",
    "_Embroidery font": properties["Embroidery font"] || ""
  };
}

function mikoPersonalisedMainNeedsAddon(main, addon) {
  if (!main) return false;
  const properties = main.properties || {};
  const hasEmbroideryText = String(properties["Embroidery first line"] || "").trim() !== "";
  const addonVariantId = Number(properties["_Miko embroidery add-on variant"] || 0);
  return hasEmbroideryText && addonVariantId > 0 && !addon;
}

let mikoEmbroideryCartRemovalInProgress = false;
async function mikoRemoveEmbroideryCartSelection({ group, itemKey, removeGarment = false, reloadPage = false } = {}) {
  if (mikoEmbroideryCartRemovalInProgress) return;
  mikoEmbroideryCartRemovalInProgress = true;
  try {
    const cart = await mikoJsonFetch(mikoCartRoutes().cart);
    const groupedItems = (cart.items || []).filter((item) => item.properties?.["_Miko embroidery group"] === group);
    const main = groupedItems.find((item) => item.properties?.["_Miko embroidery add-on"] !== "true");
    const addon = groupedItems.find((item) => item.properties?.["_Miko embroidery add-on"] === "true");

    if (removeGarment) {
      const removals = [main, addon].filter(Boolean);
      if (!removals.length && itemKey) {
        removals.push((cart.items || []).find((item) => item.key === itemKey));
      }
      for (const item of removals.filter(Boolean)) {
        await mikoJsonFetch(mikoCartRoutes().change, {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      }
    } else {
      // Shopify's Ajax Cart API cannot clear all properties from an existing
      // line once properties have been set. To genuinely remove embroidery,
      // remove the paid add-on and personalised garment line, then add the
      // same garment variant back with only its non-embroidery properties.
      // This prevents embroidery instructions reaching checkout without the fee.
      if (main) {
        const cleanItem = {
          id: Number(main.variant_id || main.id),
          quantity: main.quantity,
          properties: mikoWithoutEmbroideryProperties(main.properties)
        };
        const sellingPlanId = Number(main.selling_plan_allocation?.selling_plan?.id || 0);
        if (sellingPlanId) cleanItem.selling_plan = sellingPlanId;

        if (addon) {
          await mikoJsonFetch(mikoCartRoutes().change, {
            method: "POST",
            headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
            body: JSON.stringify({ id: addon.key, quantity: 0 })
          });
        }
        await mikoJsonFetch(mikoCartRoutes().change, {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ id: main.key, quantity: 0 })
        });
        await mikoJsonFetch(mikoCartRoutes().add, {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ items: [cleanItem] })
        });
      } else if (addon || itemKey) {
        const keyToRemove = addon?.key || itemKey;
        await mikoJsonFetch(mikoCartRoutes().change, {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ id: keyToRemove, quantity: 0 })
        });
      }
    }

    if (reloadPage) {
      window.location.reload();
      return;
    }
    await mikoRefreshCart();
  } catch (error) {
    console.warn("Unable to remove embroidery from the cart", error);
    window.alert(error.message || "Unable to remove embroidery. Please try again.");
  } finally {
    mikoEmbroideryCartRemovalInProgress = false;
  }
}

window.MikoEmbroideryCart = window.MikoEmbroideryCart || {};
window.MikoEmbroideryCart.remove = mikoRemoveEmbroideryCartSelection;

document.addEventListener("click", (event) => {
  const target = event.target.closest?.("[data-miko-embroidery-cart-remove]");
  if (!target) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const group = target.dataset.mikoEmbroideryGroup || "";
  const itemKey = target.dataset.itemId || "";
  const removeGarment = target.dataset.mikoEmbroideryRemoveMode === "garment";
  const reloadPage = Boolean(target.closest('[data-section-type="cart"]'));
  target.setAttribute("aria-busy", "true");
  target.style.pointerEvents = "none";
  mikoRemoveEmbroideryCartSelection({ group, itemKey, removeGarment, reloadPage }).finally(() => {
    target.removeAttribute("aria-busy");
    target.style.pointerEvents = "";
  });
}, true);

document.addEventListener("submit", async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const embroidery = form.querySelector('[data-miko-embroidery][data-miko-embroidery-selected="true"]');
  if (!embroidery) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const button = form.querySelector("[data-add-to-cart]");
  const variantId = Number(form.querySelector('[name="id"]')?.value || 0);
  const addonVariantId = Number(embroidery.dataset.mikoEmbroideryAddonVariantId || 0);
  const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));
  if (!variantId || !addonVariantId) {
    mikoShowFormError(form, "Please select an available size and configure the embroidery service.");
    return;
  }

  const group = mikoEmbroideryGroupId();
  const mainProperties = mikoCollectLineProperties(form);
  mainProperties["_Miko embroidery group"] = group;
  mainProperties["_Miko embroidery add-on variant"] = String(addonVariantId);
  const addonProperties = {
    "_Miko embroidery add-on": "true",
    "_Miko embroidery group": group,
    "_Miko embroidery for": embroidery.dataset.mikoEmbroideryProductTitle || "Garment",
    "_Embroidery first line": mainProperties["Embroidery first line"] || "",
    "_Embroidery second line": mainProperties["Embroidery second line"] || "",
    "_Embroidery position": mainProperties["Embroidery position"] || "",
    "_Embroidery thread colour": mainProperties["Embroidery thread colour"] || "",
    "_Embroidery font": mainProperties["Embroidery font"] || ""
  };

  const mainItem = { id: variantId, quantity, properties: mainProperties };
  const sellingPlan = form.querySelector('[name="selling_plan"]')?.value;
  if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);

  button?.classList.add("loading");
  if (button) button.disabled = true;
  try {
    const result = await mikoJsonFetch(mikoCartRoutes().add, {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify({ items: [mainItem, { id: addonVariantId, quantity, properties: addonProperties }] })
    });
    const mainAdded = result.items?.find((item) => Number(item.variant_id) === variantId) || result.items?.[0] || result;
    document.dispatchEvent(new CustomEvent("flu:cart:item-added", { detail: { product: mainAdded } }));
    const quickCart = document.body.dataset.enableQuickCart === "true";
    await mikoRefreshCart({ open: quickCart, flash: mainAdded.variant_id || variantId });
    if (!quickCart) window.location.href = mikoCartRoutes().page;
  } catch (error) {
    mikoShowFormError(form, error.message);
  } finally {
    button?.classList.remove("loading");
    if (button) button.disabled = false;
  }
}, true);

function mikoSyncEmbroideryCartFormQuantities(form) {
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.closest('[data-section-type="cart"]')) return;

  const garmentQuantities = new Map();
  form.querySelectorAll('[data-miko-embroidery-garment-quantity][data-miko-embroidery-group]').forEach((input) => {
    const group = input.dataset.mikoEmbroideryGroup || "";
    if (!group) return;
    garmentQuantities.set(group, Math.max(0, Number(input.value || 0)));
  });

  form.querySelectorAll('[data-miko-embroidery-addon-quantity][data-miko-embroidery-group]').forEach((input) => {
    const group = input.dataset.mikoEmbroideryGroup || "";
    if (!group || !garmentQuantities.has(group)) return;
    const quantity = garmentQuantities.get(group);
    input.value = String(quantity);
    const row = input.closest('.cart__item');
    const label = row?.querySelector('[data-miko-embroidery-addon-quantity-label]');
    if (label) label.textContent = `Matches garment quantity × ${quantity}`;
  });
}

// Ira's cart section uses form.submit() after the +/- buttons, which bypasses
// submit events. Mirror the linked add-on quantity as soon as the garment
// input changes so the native cart submission always includes both values.
document.addEventListener('input', (event) => {
  const input = event.target.closest?.('[data-miko-embroidery-garment-quantity]');
  if (!input) return;
  mikoSyncEmbroideryCartFormQuantities(input.form);
});

document.addEventListener('change', (event) => {
  const input = event.target.closest?.('[data-miko-embroidery-garment-quantity]');
  if (!input) return;
  mikoSyncEmbroideryCartFormQuantities(input.form);
});

document.addEventListener('click', (event) => {
  const button = event.target.closest?.('[data-section-type="cart"] [data-change]');
  if (!button) return;
  // The theme updates the number during its own click handler. Run after that
  // handler but before its delayed form.submit().
  window.setTimeout(() => {
    const form = button.closest('form');
    mikoSyncEmbroideryCartFormQuantities(form);
  }, 0);
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  mikoSyncEmbroideryCartFormQuantities(form);
}, true);

let mikoEmbroideryCartSyncing = false;
function mikoEmbroideryPairActions(cart) {
  const groups = new Map();
  (cart?.items || []).forEach((item) => {
    const group = item.properties?.["_Miko embroidery group"];
    if (!group) return;
    if (!groups.has(group)) groups.set(group, { main: null, addon: null });
    if (item.properties?.["_Miko embroidery add-on"] === "true") groups.get(group).addon = item;
    else groups.get(group).main = item;
  });

  const actions = [];
  groups.forEach(({ main, addon }, group) => {
    if (!main && addon) {
      actions.push({ type: "change", id: addon.key, quantity: 0 });
      return;
    }
    if (mikoPersonalisedMainNeedsAddon(main, addon)) {
      actions.push({
        type: "add",
        id: Number(main.properties["_Miko embroidery add-on variant"]),
        quantity: main.quantity,
        properties: mikoEmbroideryAddonPropertiesFromMain(main, group)
      });
      return;
    }
    if (main && addon && main.quantity !== addon.quantity) {
      actions.push({ type: "change", id: addon.key, quantity: main.quantity });
    }
  });
  return actions;
}

async function mikoSyncEmbroideryPairs(cart, { refresh = true, throwOnError = false } = {}) {
  if (window.Shopify?.designMode) return false;
  if (mikoEmbroideryCartSyncing || !cart?.items?.length) return false;
  const actions = mikoEmbroideryPairActions(cart);
  if (!actions.length) return false;
  mikoEmbroideryCartSyncing = true;
  try {
    for (const action of actions) {
      if (action.type === "add") {
        await mikoJsonFetch(mikoCartRoutes().add, {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ items: [{ id: action.id, quantity: action.quantity, properties: action.properties }] })
        });
      } else {
        await mikoJsonFetch(mikoCartRoutes().change, {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ id: action.id, quantity: action.quantity })
        });
      }
    }
    if (refresh) await mikoRefreshCart();
    return true;
  } catch (error) {
    console.warn("Unable to synchronise embroidery service line", error);
    if (throwOnError) throw error;
    return false;
  } finally {
    mikoEmbroideryCartSyncing = false;
  }
}

let mikoEmbroideryCheckoutGuardActive = false;
document.addEventListener("submit", async (event) => {
  const form = event.target;
  const submitter = event.submitter;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.closest('[data-section-type="cart"]')) return;
  if (!submitter || submitter.name !== "checkout") return;
  if (mikoEmbroideryCheckoutGuardActive) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  submitter.disabled = true;
  submitter.setAttribute("aria-busy", "true");
  try {
    // Apply any quantity edits currently visible in the cart before checking
    // the pairing. This covers customers who press Checkout immediately after
    // changing a quantity, before Ira's delayed native cart submission runs.
    mikoSyncEmbroideryCartFormQuantities(form);
    const cartFormData = new FormData(form);
    await mikoJsonFetch(mikoCartRoutes().update, {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body: cartFormData
    });

    const cart = await mikoJsonFetch(mikoCartRoutes().cart);
    await mikoSyncEmbroideryPairs(cart, { refresh: false, throwOnError: true });
    const verifiedCart = await mikoJsonFetch(mikoCartRoutes().cart);
    if (mikoEmbroideryPairActions(verifiedCart).length) {
      throw new Error("We could not verify the embroidery charge. Please refresh the cart and try again.");
    }
    mikoEmbroideryCheckoutGuardActive = true;
    submitter.disabled = false;
    submitter.removeAttribute("aria-busy");
    form.requestSubmit(submitter);
  } catch (error) {
    window.alert(error.message || "Unable to verify embroidery before checkout. Please try again.");
    submitter.disabled = false;
    submitter.removeAttribute("aria-busy");
  }
}, true);

document.addEventListener("flu:cart:updated", (event) => mikoSyncEmbroideryPairs(event.detail?.cart));

async function mikoRepairEmbroideryQuantitiesOnLoad() {
  if (window.Shopify?.designMode) return;
  try {
    const cart = await mikoJsonFetch(mikoCartRoutes().cart);
    const actions = mikoEmbroideryPairActions(cart);
    if (!actions.length) return;
    const changed = await mikoSyncEmbroideryPairs(cart, { refresh: false });
    if (changed && document.querySelector('[data-section-type="cart"]')) {
      window.location.reload();
    } else if (changed) {
      await mikoRefreshCart();
    }
  } catch (error) {
    console.warn("Unable to repair embroidery quantities on load", error);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mikoRepairEmbroideryQuantitiesOnLoad, { once: true });
} else {
  mikoRepairEmbroideryQuantitiesOnLoad();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => mikoInitEmbroidery());
} else {
  mikoInitEmbroidery();
}
window.addEventListener("pageshow", (event) => {
  if (!event.persisted) return;
  document.querySelectorAll("[data-miko-embroidery]").forEach((widget) => mikoRemoveEmbroidery(widget));
});
document.addEventListener("quickview:loaded", () => mikoInitEmbroidery());
document.addEventListener("shopify:section:load", (event) => mikoInitEmbroidery(event.target));
document.addEventListener("shopify:section:unload", (event) => {
  event.target.querySelectorAll("[data-miko-embroidery]").forEach((widget) => {
    mikoCloseEmbroidery(widget);
    mikoCloseEmbroideryInfo(widget);
  });
  document.body.classList.remove("miko-embroidery-modal-open");
});


// Miko cart-page quantity transaction fix.
// Ira's native cart handler submits the form after a delay. For personalised
// garments, update the garment and paid embroidery line in one Cart API call
// so their quantities and prices can never drift apart.
let mikoCartPageQuantityUpdateInProgress = false;

function mikoCartPageBuildUpdates(form) {
  const updates = {};
  const garmentQuantities = new Map();

  form.querySelectorAll('[data-miko-embroidery-garment-quantity][data-miko-embroidery-group]').forEach((input) => {
    const group = input.dataset.mikoEmbroideryGroup || '';
    if (!group) return;
    garmentQuantities.set(group, Math.max(0, Number(input.value || 0)));
  });

  form.querySelectorAll('[name="updates[]"][data-miko-cart-item-key]').forEach((input) => {
    const key = input.dataset.mikoCartItemKey || '';
    if (!key) return;
    const group = input.dataset.mikoEmbroideryGroup || '';
    const quantity = group && garmentQuantities.has(group)
      ? garmentQuantities.get(group)
      : Math.max(0, Number(input.value || 0));
    input.value = String(quantity);
    updates[key] = quantity;
  });

  form.querySelectorAll('[data-miko-embroidery-addon-quantity-label]').forEach((label) => {
    const row = label.closest('.cart__item');
    const input = row?.querySelector('[data-miko-embroidery-addon-quantity]');
    const group = input?.dataset.mikoEmbroideryGroup || '';
    if (group && garmentQuantities.has(group)) {
      label.textContent = `Matches garment quantity × ${garmentQuantities.get(group)}`;
    }
  });

  return updates;
}

async function mikoSubmitCartPageQuantities(form, trigger) {
  if (mikoCartPageQuantityUpdateInProgress) return;
  mikoCartPageQuantityUpdateInProgress = true;
  form.classList.add('is-updating');
  trigger?.setAttribute('aria-busy', 'true');
  form.querySelectorAll('button, input[type="submit"], [data-change]').forEach((element) => {
    element.dataset.mikoWasDisabled = element.disabled ? 'true' : 'false';
    if ('disabled' in element) element.disabled = true;
    element.style.pointerEvents = 'none';
  });

  try {
    const updates = mikoCartPageBuildUpdates(form);
    await mikoJsonFetch(mikoCartRoutes().update, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates })
    });
    window.location.reload();
  } catch (error) {
    console.warn('Unable to update personalised cart quantities', error);
    window.alert(error.message || 'Unable to update the cart. Please try again.');
    form.classList.remove('is-updating');
    trigger?.removeAttribute('aria-busy');
    form.querySelectorAll('button, input[type="submit"], [data-change]').forEach((element) => {
      if ('disabled' in element && element.dataset.mikoWasDisabled !== 'true') element.disabled = false;
      element.style.pointerEvents = '';
      delete element.dataset.mikoWasDisabled;
    });
    mikoCartPageQuantityUpdateInProgress = false;
  }
}

// Capture personalised +/- clicks before Ira's delayed form.submit() handler.
document.addEventListener('click', (event) => {
  const button = event.target.closest?.('[data-section-type="cart"] [data-change]');
  if (!button) return;
  const input = button.parentElement?.querySelector('[data-miko-embroidery-garment-quantity]');
  if (!input) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const current = Math.max(0, Number(input.value || 0));
  input.value = String(button.dataset.change === 'increment' ? current + 1 : Math.max(0, current - 1));
  const form = button.closest('form');
  if (form) mikoSubmitCartPageQuantities(form, button);
}, true);

// Make the Update button use the same atomic server-side update whenever the
// cart contains a personalised garment. Checkout is handled by the existing
// embroidery integrity guard.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.closest('[data-section-type="cart"]')) return;
  if (!form.querySelector('[data-miko-embroidery-garment-quantity]')) return;
  const submitter = event.submitter;
  if (submitter?.name === 'checkout') return;

  event.preventDefault();
  event.stopImmediatePropagation();
  mikoSubmitCartPageQuantities(form, submitter);
}, true);
